import * as React from "react";
import { useCallback } from "react";
import HighlightingRules from "views/components/sidebar/highlighting/HighlightingRules";
const DESCRIPTION = "Field values can be highlighted. If a term or a value has more than one rule, the first matching rule is used.";
const DataLakeHighlightingRules = ({ setHighlightingRules }) => {
  const onUpdateRule = useCallback(
    (targetRule, newField, newValue, newCondition, newColor) => {
      setHighlightingRules((cur) => {
        const newCur = [...cur];
        const index = newCur.findIndex((rule) => rule === targetRule);
        if (index === -1) {
          return newCur;
        }
        newCur[index] = targetRule.toBuilder().color(newColor).field(newField).value(newValue).condition(newCondition).build();
        return newCur;
      });
      return Promise.resolve();
    },
    [setHighlightingRules]
  );
  const onCreateRule = useCallback(
    (newRule) => {
      setHighlightingRules((cur) => [...cur, newRule]);
      return Promise.resolve();
    },
    [setHighlightingRules]
  );
  const onUpdateRules = useCallback(
    (newRules) => {
      setHighlightingRules(newRules);
      return Promise.resolve();
    },
    [setHighlightingRules]
  );
  const onDeleteRule = useCallback(
    (rule) => {
      setHighlightingRules((cur) => cur.filter((r) => r !== rule));
      return Promise.resolve();
    },
    [setHighlightingRules]
  );
  return /* @__PURE__ */ React.createElement(
    HighlightingRules,
    {
      description: DESCRIPTION,
      onDeleteRule,
      onUpdateRules,
      onUpdateRule,
      onCreateRule,
      showSearchHighlightInfo: false
    }
  );
};
export default DataLakeHighlightingRules;
